export enum ECostFormulaActionType {
  GET_COST_FORMULAS = 'GET_COST_FORMULAS',
  GET_COST_FORMULAS_SUCCESS = 'GET_COST_FORMULAS_SUCCESS',
  GET_COST_FORMULAS_FAIL = 'GET_COST_FORMULAS_FAIL',
}

export enum ECostFormulaType {
  ITP = 'itp',
  TRUE_COST = 'true cost',
  HELPER = 'helper',
}

// CostFormula holds all of the information needed for a single production cost or an intermediate
// value used in other production cost formulas.
export interface ICostFormula {
  name: string;
  type: ECostFormulaType;
  formula: string;
  dependencies: string[] | null;
}

// A FormulaGroup holds a list of formulas that represent different types of the same thing.
export interface ICostFormulaGroup {
  type?: string;
  name: string;
  formulas: ICostFormula[];
}

export interface ICostFormulasState {
  loading: boolean;
  error?: string | Error | null;
  data: ICostFormulaGroup[];
}
